import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box } from "@mui/material";

import { Text } from "../../components/Text";

/**
 * Display a message when an admin views the chat in read-only mode.
 * Admins cannot send messages - only workplace users can.
 */
export function ChatAdminReadOnly() {
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        alignItems: "center",
        gap: 2,
        padding: 3,
        backgroundColor: theme.palette.background.default,
        borderRadius: theme.borderRadius?.medium,
      })}
    >
      <InfoOutlinedIcon
        sx={(theme) => ({
          fontSize: "20px",
          color: theme.palette.primary.main,
        })}
      />
      <Text
        variant="body2"
        sx={(theme) => ({
          color: theme.palette.text.secondary,
        })}
      >
        Only workplace users can send messages
      </Text>
    </Box>
  );
}
